import { render, staticRenderFns } from "./TicketOptionsContactModal.vue?vue&type=template&id=101ff486&scoped=true"
import script from "./TicketOptionsContactModal.vue?vue&type=script&lang=js"
export * from "./TicketOptionsContactModal.vue?vue&type=script&lang=js"
import style0 from "./TicketOptionsContactModal.vue?vue&type=style&index=0&id=101ff486&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101ff486",
  null
  
)

export default component.exports